import { render } from "./DraftBillsCapturedPanel.vue?vue&type=template&id=3a36cabd&scoped=true"
import script from "./DraftBillsCapturedPanel.vue?vue&type=script&lang=js"
export * from "./DraftBillsCapturedPanel.vue?vue&type=script&lang=js"

import "./DraftBillsCapturedPanel.vue?vue&type=style&index=0&id=3a36cabd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a36cabd"]])

export default __exports__